import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import logo from '../logo.png'; 

function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false); // Dropdown hafızası

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  // Linklere tıklanınca tüm menüleri kapatan akıllı fonksiyon
  const handleLinkClick = () => {
    setIsOpen(false);
    setDropdownOpen(false);
  };

  return (
    <nav className="navbar">
      <div className="logo-container">
        <Link to="/" onClick={handleLinkClick}>
          <img src={logo} alt="Demir Grup Logo" className="navbar-logo" />
        </Link>
      </div>

      <div className="mobile-nav-title">
        <span className="brand-name">DEMİR GRUP</span>
        <span className="brand-sub">İNŞAAT & GÜVENLİK</span>
      </div>
      
      {/* Hamburger Menü İkonu */}
      <div className={`hamburger ${isOpen ? 'active' : ''}`} onClick={toggleMenu}>
        <span className="bar"></span>
        <span className="bar"></span>
        <span className="bar"></span>
      </div>

      <ul className={`nav-links ${isOpen ? 'show' : ''}`}>
        <li><Link to="/" onClick={handleLinkClick}>Ana Sayfa</Link></li>
        <li><Link to="/kamera" onClick={handleLinkClick}>Kameralarımız</Link></li>

        {/* --- YENİ EFSANEVİ AÇILIR MENÜ (DROPDOWN) --- */}
        <li 
          className="dropdown"
          onMouseEnter={() => setDropdownOpen(true)}
          onMouseLeave={() => setDropdownOpen(false)}
          onClick={() => setDropdownOpen(!dropdownOpen)} // Mobilde dokunmatik için
        >
          <div className="dropbtn">
            Ürünler <span className={`arrow ${dropdownOpen ? 'up' : 'down'}`}>▾</span>
          </div>
          
          <ul className={`dropdown-content ${dropdownOpen ? 'show-drop' : ''}`}>
            <li><Link to="/urunler/guvenlik-fileleri" onClick={handleLinkClick}>Güvenlik Fileleri</Link></li>
            <li><Link to="/urunler/is-guvenligi" onClick={handleLinkClick}>İş Güvenliği Ekipmanları</Link></li>
            <li><Link to="/urunler/zayif-akim" onClick={handleLinkClick}>Zayıf Akım</Link></li>
          </ul>
        </li>
        {/* ------------------------------------------- */}

        <li><Link to="/iletisim" onClick={handleLinkClick}>İletişim</Link></li>
        <li><Link to="/projeler" onClick={handleLinkClick}>Projeler</Link></li>
        <li className="mobile-only">
          <button className="contact-btn">Bize Ulaşın</button>
        </li>
      </ul>

      <div className="nav-actions desktop-only">
        <button className="contact-btn">Bize Ulaşın</button>
      </div>
    </nav>
  );
}

export default Navbar;